const smDesktopMediaQuery = window.matchMedia('(max-width: 1024px)');

function placeCountdown(matches) {
  const htCd = $('.header-top #siteInfoBannerWidget');
  const hICCd = $('.headerInnerContent > #siteInfoBannerWidget');
  const hIC = $('.headerInnerContent');
  const logo = $('.header-top .header-logo');

  if (matches) {
    if (htCd.length) {
      htCd.appendTo(hIC);
    }
  } else {
    if (hICCd.length) {
      hICCd.insertBefore(logo);
    }
  }
}

function handleHeaderChange(e) {
  if (e.matches) {
    placeCountdown(true); 
  } else {
    placeCountdown(false); 
  }
}




$(document).ready(function() {
  const header = $('.header');

  // prepend generalmessage to header
  $('.generalmessage').prependTo(header);

  const $emailSignup = $('.footer .emailSignup');
  $emailSignup.find('.emailSubmitButton').text('Sign Up');
  $emailSignup.find('.inputFieldTextbox').val('');
  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Email Address');
  $emailSignup.find('.emailSignupText').html("Don't miss our on upcoming<br> events and entertainment.");
  $emailSignup.prepend('<span class="f-col-heading">Get Updates!</span>');

  // set ticket button url
  $('.ticket-btn').attr('href', $('.ticket').attr('href'));

  // place header cart and countdown
  smDesktopMediaQuery.addListener(handleHeaderChange);
  handleHeaderChange(smDesktopMediaQuery);

  // set footer saffire logo image
  $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);



});
